<template>
    <div class="breadcrumbs">
        <b-breadcrumb :items="dom"/>
    </div>
</template>

<script>
export default {
    name:'breadcrumb',
    props:{ // 可從外面吃到裡面的功能
        dom:{
            type:Array,
            required:true
        }
    },
}
</script>